import { Params, redirect } from "react-router-dom";
import { RootStore } from "../../../stores/root-store";
import { TransportError } from "../../../stores/data-transporter";

export async function action(
    params: Params,
    rootStore: RootStore
) {
    if (params.contactId !== undefined) {
        try {
            const contactId = parseInt(params.contactId) || 0;
            const rootStoreSession = rootStore.session;
            await rootStoreSession.contactStore.delete(contactId);
            return redirect(`/kontakte`);
        } catch (error: TransportError) {
            throw new Response("", {
                status: error.statusCode,
                statusText: "Kontakt wurde nicht gefunden",
            })
        }
    }
}
